import { selectMentoryCatgeory } from "./actions";
import { useDispatch, useSelector } from "react-redux";
import { useCallback } from "react";
import { useQuery, useQueryWithStore } from "react-admin";
import Parse from "parse";

export const useMentorCategory = () => {
  const dispatch = useDispatch();
  const selectMentorCategory = useCallback(
    (category) => dispatch(selectMentoryCatgeory(category)),
    [dispatch]
  );
  const industryCategoryList = useQueryWithStore({
    type: "getList",
    resource: "Industry",
    payload: {
      filter: {},
      pagination: { page: 1, perPage: 10 },
      sort: { field: "id", order: "DSC" },
    },
  });
  return {
    selectMentorCategory,
    industryCategoryList,
  };
};

export const useSubscription = (mentorId) => {
  console.log("mentorId", mentorId);
  async function GetSubscriber(mentorId) {
    const User = Parse.Object.extend("User")
    const Subscription = Parse.Object.extend("Subscription")
    const UserQuery = new Parse.Query(User)
    const SubscriptionQuery = new Parse.Query(Subscription)
    const Menor = await UserQuery.get(mentorId)
    await SubscriptionQuery.equalTo("mentorId",Menor)
    await SubscriptionQuery.find()
    const Count = await SubscriptionQuery.count()
    console.log("Count",Count)
    return Count
  }
  return { GetSubscriber };
};

export const useMentorData = () => {
  const mentorCategory = useSelector(
    (state) => state.userStats.selectedMentorCategory
  );
  console.log("mentorCategory", mentorCategory);
  const filters =
    mentorCategory !== "All"
      ? {
          industry: mentorCategory,
        }
      : {};
  const mentorData = useQuery({
    type: "getList",
    resource: "User",
    payload: {
      filter: {
        isMentor: true,
        profileVerified: true,
        // objectId:localStorage.getItem("user"),
        ...filters,
      },
      pagination: { page: 1, perPage: 1000 },
      sort: { field: "id", order: "DSC" },
    },
  });

  mentorData.data = mentorData.loaded
    ? mentorData.data.filter(
        (value) => value.id !== localStorage.getItem("user")
      )
    : [];
  // const Badge = Parse.Object.extend("UserBadge");

  // let PostsData = mentorData.loaded ? async()=>{
  // await Promise.all(
  //   mentorData.data.map(async (mentor) => {
  //     console.log("mentor", mentor);
  //     const PostData = mentor.toJSON();
  //     const BadgeQuery = new Parse.Query(Badge);
  //     const MainBadge = await BadgeQuery.get(
  //       mentor.userBadge.id
  //     );
  //     PostData["userBadge"] = {
  //       id: MainBadge.id,
  //       ...MainBadge.attributes,
  //     };
  //     let returnData = {
  //       id: PostData.id,
  //       ...PostData,
  //      };
  //     return returnData;
  //   })
  // ):[]
  // }

  // console.log("PostsData",PostsData)
  console.log("mentorData", mentorData);

  return {
    mentorData,
  };
};

export const useMentorAvailabilityDetails = ({ aid }) => {
  const useMentorAvailability = useQueryWithStore({
    type: "getOne",
    resource: "Availability",
    filter: {
      id: aid,
    },
  });

  return useMentorAvailability;
};

export const GetOffers = (mentorId) => {
  console.log("GetOffers", mentorId);
  const OfferList = useQueryWithStore({
    type: "getList",
    resource: "Offer",
    payload: {
      filter: { user: mentorId },
      pagination: { page: 1, perPage: 10 },
      sort: { field: "id", order: "DSC" },
    },
  });
  console.log("OfferList", OfferList);

  return {
    OfferList,
  };
};
